import React, { useState } from "react";
import { PatientChartLabPanel } from "./PatientChartLabPanel";
import { QualifiedFeatureFragment } from "fe-common/graphql";
import { PatientChartSubGroupTitle } from "./PatientChartSubGroupTitle";
import { PatientCaseGrouping } from "../../../context/diagnosticAgent";
import styled from "@mui/material/styles/styled";
import { RosebudColorMap } from "../rosebud/rosebudColorMap";
import { MobileView } from "../../../util/aKaunGeneralUtil";
import { useLabPanels } from "../useLabsPanels";
import { KahunPanelSubGroup } from "shared";
import { PatientChartProcedurePanel } from "./PatientChartProcedurePanel";

//region [[ Styles ]]

const ShowAllText = styled("div")(({ theme }) => ({
  fontWeight: 500,
  fontSize: "14px",

  [theme.breakpoints.down(MobileView)]: {
    marginRight: "10px",
  },

  color: RosebudColorMap.gray2,
}));

//endregion [[ Styles ]]

//region [[ Props ]]

export interface PatientChartWorkupPanelsProps {
  qfs: QualifiedFeatureFragment[];
  gotoSection: (subGroupId, panelId) => void;
  subGroupId: string;
  section: PatientCaseGrouping;
  onRemove: (f: any) => void;
  gotoDataInput: (section, subgroupId) => void;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const PatientChartWorkupPanels = ({
  ...props
}: PatientChartWorkupPanelsProps) => {
  const [showMore, setShowMore] = useState(false);
  const isLabs = true;

  const labsPanels = useLabPanels(props.subGroupId, props.qfs);

  const gotoPanel = (panelId) => {
    props.gotoSection(props.subGroupId, panelId);
  };

  const onShowAll = (event) => {
    event.stopPropagation();
    setShowMore(!showMore);
  };

  return (
    <>
      <PatientChartSubGroupTitle
        subGroupId={props.subGroupId}
        gotoDataInput={props.gotoDataInput}
        section={props.section}
        element={
          isLabs && labsPanels.length > 0 ? (
            <ShowAllText onClick={onShowAll}>
              {showMore ? "Show only Abnormal" : "Show All"}
            </ShowAllText>
          ) : (
            <></>
          )
        }
      />

      {props.subGroupId === KahunPanelSubGroup.Labs &&
        labsPanels.map((labPanel, index) => {
          return (
            <PatientChartLabPanel
              key={index}
              showAll={showMore}
              subGroupId={props.subGroupId}
              panel={labPanel.panel}
              gotoSection={gotoPanel}
              findings={labPanel.findings}
              onRemove={props.onRemove}
            />
          );
        })}

      {props.subGroupId === KahunPanelSubGroup.Procedures &&
        labsPanels.map((labPanel, index) => {
          return (
            <PatientChartProcedurePanel
              key={index}
              showAll={showMore}
              subGroupId={props.subGroupId}
              panel={labPanel.panel}
              gotoSection={gotoPanel}
              findings={labPanel.findings}
              onRemove={props.onRemove}
            />
          );
        })}
    </>
  );
};
